import { render, staticRenderFns } from "./PageTopContent.vue?vue&type=template&id=dcf88b24&"
import script from "./PageTopContent.vue?vue&type=script&lang=ts&"
export * from "./PageTopContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports